import React from 'react'
import styled from 'styled-components'
import { Spinner } from '@fluentui/react-components'
import { COLORS } from '../../constants'

type LoadingSpinnerProps = {
  height?: string
}

const Container = styled.div<{ $height: string }>`
  display: flex;
  justify-content: center;
  background-color: ${COLORS.gray};
  align-items: center;
  height: ${({ $height }) => $height}vh;
`

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ height }) => {
  return (
    <Container $height={height || '100'}>
      <Spinner label="Loading..." size="extra-large" />
    </Container>
  )
}

export default LoadingSpinner
